import { Heading } from '@expressable/syntax-ds';
import { Fragment } from 'react';
import { OutcomeTile } from './OutcomeTile';
import { Sid_SpeechTherapy, Gus_HomePractice, Scribby_Stars, Squash_Stairs } from 'assets/images/signup';
import { useTranslation } from 'react-i18next';

const tiles = new Map<string, string>([
  ['tile_1', Sid_SpeechTherapy],
  ['tile_2', Gus_HomePractice],
  ['tile_3', Scribby_Stars],
  ['tile_4', Squash_Stairs],
]);

export const OutcomesTiles = () => {
  const { t } = useTranslation();

  return (
    <div className="flex flex-row flex-wrap gap-x-e32 gap-y-e24 w-full justify-evenly items-baseline">
      <Heading level="h2" className="text-center">
        {t('directSignup.sections.outcomesTiles.headLine')}
      </Heading>
      {[...tiles.entries()].map(([tileName, iconName], index) => {
        const heading = t(`directSignup.sections.outcomesTiles.${tileName}.heading`);
        const description = t(`directSignup.sections.outcomesTiles.${tileName}.description`);

        return (
          <Fragment key={index}>
            <OutcomeTile heading={heading} description={description} icon={iconName} />
          </Fragment>
        );
      })}
    </div>
  );
};
